export default "__VITE_ASSET__Ba3XOv0R__"